/* unplugin-vue-components disabled */import script from "./UserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__